import { render, staticRenderFns } from "./m-addAnswerChild.vue?vue&type=template&id=20fe96ee&"
import script from "./m-addAnswerChild.vue?vue&type=script&lang=js&"
export * from "./m-addAnswerChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports